// https://github.com/jorgegorka/svelte-router/blob/master/README.md

import DefaultLayout from './layout.svelte';
import Index from './routes/Index.svelte';
import Admin from './routes/Admin.svelte';
import Feedback from './routes/Feedback.svelte';

import Login from './routes/Login.svelte';
import Auth from './routes/Auth.svelte';
import Logout from './routes/Logout.svelte';

import Shops from './routes/Shops.svelte';
import Places from './routes/Places.svelte';
import Account from './routes/Account.svelte';
import Navigator from './routes/Navigator.svelte';

import ComingSoon from './routes/ComingSoon.svelte';

import API from './routes/API.svelte';

const routes = [
    {
        name: '/',
        component: Index,
        layout: DefaultLayout,
    },
    {
        name: '/admin',
        component: Admin,
        layout: DefaultLayout,
        onlyIf: { guard: () => {
            if (window.localStorage.getItem('player') && JSON.parse(window.localStorage.getItem('player')).PlayerDiscord == 349062232652382220) return true;
        }, redirect: '/login' },
    },
    {
        name: '/feedback',
        component: Feedback,
        layout: DefaultLayout,
    },

    // Authentication Stuff

    {
        name: '/login',
        component: Login,
        layout: DefaultLayout,
    },
    {
        name: '/auth',
        component: Auth,
        layout: DefaultLayout,
    },
    {
        name: '/logout',
        component: Logout,
        layout: DefaultLayout,
    },

    // Functions

    {
        name: '/shops/:id',
        component: Shops,
        layout: DefaultLayout,
    },
    {
        name: '/places/:id',
        component: Places,
        layout: DefaultLayout,
    },
    {
        name: '/navigator',
        // component: Navigator,
        component: ComingSoon,
        layout: DefaultLayout,
    },
    {
        name: '/account',
        component: Account,
        layout: DefaultLayout,
        onlyIf: { guard: () => {
            if (window.localStorage.getItem('player') && JSON.parse(window.localStorage.getItem('player')) != {}) return true;
        }, redirect: '/login' },
    },

    // Other Stuff

    {
        name: '/api',
        // component: API,
        component: ComingSoon,
        layout: DefaultLayout,
    },
    {
        name: '404',
        component: Index,
        layout: DefaultLayout,
    },
]

export {
    routes
}